import React, { useState, useRef } from "react"
import axios from 'axios';
// import { trackEvent } from "../../facebookPixel";
import ReCAPTCHA from 'react-google-recaptcha';
import { fireRedTrackLead } from "../../redtrack";
import { ArrowRightIcon, PhoneIcon } from '@heroicons/react/solid';
import { useLocation } from "react-router-dom";



export default function TaxReliefForm() {
    const recaptchaRef = useRef(null);
    const [status, setStatus] = useState('');
    const [step, setStep] = useState(1)
    const [showCallNow, setShowCallNow] = useState(false);
    const location = useLocation();



    const [formData, setFormData] = useState({
        taxDebt: 10000,
        state: "California",
        firstName: "",
        lastName: "",
        email: "",
        emailConsent: true,
        phone: "",
        phoneConsent: false,
        estimateDebt: 5000,
        taxDebtType: "",
        taxDebtKind: "Most of my tax debt is income tax (personal or business)",
        grossMonthlyIncome: 5000,
        enrollmentPlan: "",
        creditScore: "620 - 739",
        unfiledTaxReturns: "",
        cellPhone: "",
        description: "",
    })

    const [errors, setErrors] = useState({})

    const updateField = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }))
    }

    const nextStep = () => {
        setStep((prev) => prev + 1)
    }

    const prevStep = () => {
        setStep((prev) => prev - 1)
    }

    const handleNextClick = (e, field, value) => {
        // console.log(field, value);
        updateField(field, value);
        nextStep()
    }

    const validateStep = () => {
        let newErrors = {};

        switch (step) {
            case 1:
                if (!formData.taxDebtType) {
                    newErrors.taxDebtType =
                        "Please select an option.";
                }
                break;

            case 2:
                if (!formData.taxDebt) {
                    newErrors.taxDebt =
                        "Please enter your estimated tax debt.";
                }
                break;

            case 3:
                if (!formData.unfiledTaxReturns) {
                    newErrors.unfiledTaxReturns =
                        "Please select an option.";
                }
                break;

            case 4:
                if (!formData.taxDebtKind) {
                    newErrors.taxDebtKind =
                        "Please select an option.";
                }
                break;

            case 5:
                if (!formData.grossMonthlyIncome) {
                    newErrors.grossMonthlyIncome =
                        "Please enter your monthly income.";
                }
                break;

            case 6:
                if (!formData.creditScore) {
                    newErrors.creditScore =
                        "Please select your credit score.";
                }
                break;

            case 7:
                if (!formData.enrollmentPlan) {
                    newErrors.enrollmentPlan =
                        "Please select an option.";
                }
                break;

            case 8:
                if (!formData.firstName.trim()) {
                    newErrors.firstName =
                        "First name is required.";
                }

                if (!formData.lastName.trim()) {
                    newErrors.lastName =
                        "Last name is required.";
                }

                const emailRegex =
                    /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                if (
                    !formData.email ||
                    !emailRegex.test(formData.email)
                ) {
                    newErrors.email =
                        "Please enter a valid email.";
                }

                const cleanedPhone =
                    formData.phone.replace(/\D/g, "");

                if (cleanedPhone.length !== 10) {
                    newErrors.phone =
                        "Please enter a valid phone number.";
                }
                break;

            default:
                break;
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const getTaxDebtRange = (amount) => {
        const value = Number(amount)

        if (value >= 1 && value <= 4999) {
            return "$1 - $4,999"
        }

        if (value >= 5000 && value <= 9999) {
            return "$5,000 - $9,999"
        }

        if (value >= 10000 && value <= 29999) {
            return "$10,000 - $29,999"
        }

        if (value >= 30000 && value <= 49999) {
            return "$30,000 - $49,999"
        }

        if (value >= 50000) {
            return "$50,000 or more"
        }

        return ""
    }

    const getGrossMonthlyRange = (amount) => {
        const value = Number(amount)

        if (value >= 1 && value <= 999) {
            return "$1 - $999"
        }

        if (value >= 1000 && value <= 2499) {
            return "$1,000 - $2,499"
        }

        if (value >= 2500 && value <= 5000) {
            return "$2,500 - $5,000"
        }

        if (value >= 5000 && value <= 10000) {
            return "$5,000 - $10,000"
        }

        if (value >= 10000) {
            return "Over $10,000"
        }

        return ""
    }


    const handleNext = async (e) => {
        e.preventDefault();
        const taxDebtRange = getTaxDebtRange(formData.taxDebt)
        const taxGrossMonthlyRange = getGrossMonthlyRange(formData.grossMonthlyIncome)

        const isValid = validateStep()

        if (!isValid) return


        // Submit form on last step
        if (step === 8) {
            try {
                // console.log("step 8")
                // 1. Get reCAPTCHA token
                const recaptchaToken = await recaptchaRef.current.executeAsync();
                recaptchaRef.current.reset();

                // console.log("last step")

                const payloadData =
                {
                    "email": formData.email,
                    "firstname": formData.firstName,
                    "lastname": formData.lastName,
                    "phone": formData.phone,
                    // "state": formData.state,
                    "landing_page": location.pathname,
                    "amount": formData.taxDebt,
                    "how_much_do_you_estimate_you_owe_in_back_taxes_": taxDebtRange,
                    "i_affirm_that_i_ve_reviewed_and_accepted_ovation_tax_group_sterms_and_conditionsandprivacy_policy_": formData.emailConsent,
                    "by_checking_this_box__i_agree_to_receive_communications__including_email__calls_and_text_messages_f": formData.emailConsent,
                    "are_you_currently_enrolled_in_a_payment_installment_agreement_": formData.enrollmentPlan,
                    "do_you_have_tax_debt_with_the_irs_or_your_state_": formData.taxDebtType,
                    "gross_monthly_income": taxGrossMonthlyRange,
                    "credit_score": formData.creditScore,
                    "do_have_one_or_more_unfiled_tax_returns_": formData.unfiledTaxReturns,
                    "what_kind_of_tax_debt_do_you_need_help_with_": formData.taxDebtKind,
                }
                // console.log("last step", payloadData)

                // 2. Verify reCAPTCHA via Vercel serverless function
                const res = await fetch('/api/verify-recaptcha', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ token: recaptchaToken }),
                });
                const data = await res.json();

                if (!data.success) {
                    // console.error('Recaptcha failed:', data);
                    // Show error to user
                    setStatus('Failed reCAPTCHA. Please try again.');
                }
                // 2c. get cookie value for hubspot click id
                function getCookie(name) {
                    const prefix = `${name}=`;

                    const entry = document.cookie
                        .split("; ")
                        .find((item) => item.startsWith(prefix));

                    return entry
                        ? decodeURIComponent(entry.slice(prefix.length))
                        : "";
                }

                const trackingContext = {
                    hubspotutk: getCookie("hubspotutk") || "",
                    pageUrl: window.location.href,
                    pageName: document.title,
                };


                // 3. Send data to HubSpot
                const clickId = sessionStorage.getItem("rt_clickid") || "";

                const payload = {
                    ...payloadData,
                    ...trackingContext,
                    rtkclickid: clickId
                };

                const response = await axios.post('/api/hubspot-lead', payload);

                if (response.data.existingContact) {
                    // Show Call Now screen
                    setShowCallNow(true);
                    return;
                }

                if (response.status === 200) {
                    console.log('Lead submitted successfully');
                    // Fire RedTrack Lead event
                    fireRedTrackLead({
                        email: formData.email,
                        phone: formData.phone,
                        firstName: formData.firstName,
                        lastName: formData.lastName
                    });


                    // Facebook Lead Event
                    // trackEvent('Lead', { content_name: 'Signup Form' });

                    // Success modal
                    nextStep()
                }


            } catch (error) {
                alert("Something went wrong. Please try again. ")
                setStatus('Something went wrong. Please try again.');
            }
        } else {
            nextStep()
        }
    }

    return (
        <div id="start">
            <div className="bg-sky-700 p-5 text-white text-3xl font-semibold text-center">
                The IRS Settled $192 Million in 2025
            </div>

            {showCallNow ?
                <div className="w-full mx-auto bg-white shadow-md p-6 text-center">
                    <h2 className="text-3xl font-bold">
                        We've Already Received Your Information
                    </h2>

                    <p className="mt-4 text-xl">
                        To avoid waiting for a callback, call now to speak directly with a tax relief specialist. Our team can <b>review your situation immediately</b> and answer any questions about your options.
                    </p>

                    <a
                        href="tel:8449844926"
                        className="mt-8 inline-block bg-green-600 hover:bg-green-700 text-white text-2xl font-bold px-10 py-5 rounded-lg"
                    >
                        Call (844) 984-4926
                    </a>

                    <p className="mt-4 text-gray-600">
                        Representatives are standing by.
                    </p>
                </div>

                :
                <div className={`w-full mx-auto bg-white shadow-md p-6 transition-all duration-300 ${step === 8
                    ? "min-h-[500px]"
                    : "min-h-[200px]"
                    }`} id="start">

                    {/* STEP 1 */}
                    {step === 1 && (
                        <fieldset id="step1">
                            <legend className="text-2xl text-center text-gray-800 font-semibold min-w-sm max-w-sm">
                                Do you currently have tax debt with the IRS?
                            </legend>

                            <div className="flex items-center justify-center gap-6 mt-6">
                                <button className="flex items-center justify-center w-full border hover:border-gray-300 bg-white hover:bg-gray-100 hover:text-gray-900 text-gray-800 text-xl py-4 rounded-lg font-bold uppercase"
                                    type="button"
                                    onClick={(e) => {
                                        console.log("Clicked!");
                                        handleNextClick(e, "taxDebtType", "Yes");
                                    }}
                                // onClick={() => handleNextClick('taxDebtType', "Yes")}
                                >
                                    Yes
                                </button>

                                <button className="flex items-center justify-center w-full border hover:border-gray-300 bg-white hover:bg-gray-100 hover:text-gray-900 text-gray-800 text-xl py-4 rounded-lg font-bold uppercase"
                                    type="button"
                                    onClick={(e) => handleNextClick(e, 'taxDebtType', "No")}
                                >
                                    No
                                </button>
                            </div>
                        </fieldset>
                    )}

                    {/* STEP 2 */}
                    {step === 2 && (
                        <fieldset id="step2">
                            <legend className="text-2xl text-center text-gray-800 font-semibold min-w-sm max-w-sm">
                                Approximately, how much do you estimate you owe in back taxes?
                            </legend>

                            <div className="mt-6">
                                <input
                                    type="range"
                                    min="1000"
                                    max="100000"
                                    step="1000"
                                    value={formData.taxDebt}
                                    onChange={(e) =>
                                        updateField(
                                            "taxDebt",
                                            e.target.value
                                        )
                                    }
                                    className="custom-slider w-full"
                                />

                                <p className="text-center mt-3 text-2xl font-medium">
                                    $
                                    {Number(
                                        formData.taxDebt
                                    ).toLocaleString()}
                                </p>

                                {errors.taxDebt && (
                                    <p className="text-red-500 mt-2">
                                        {errors.taxDebt}
                                    </p>
                                )}
                            </div>
                        </fieldset>
                    )}

                    {/* STEP 3 */}
                    {step === 3 && (
                        <fieldset id="step3">
                            <legend className="text-2xl text-center text-gray-800 font-semibold min-w-sm max-w-sm">
                                Do you have unfiled tax returns?
                            </legend>

                            <div className="flex items-center justify-center gap-6 mt-6">
                                <button className="flex items-center justify-center w-full border hover:border-gray-300 bg-white hover:bg-gray-100 hover:text-gray-900 text-gray-800 text-xl py-4 rounded-lg font-bold uppercase"
                                    type="button"
                                    onClick={(e) => handleNextClick(e, 'unfiledTaxReturns', "Yes")}
                                >
                                    Yes
                                </button>

                                <button className="flex items-center justify-center w-full border hover:border-gray-300 bg-white hover:bg-gray-100 hover:text-gray-900 text-gray-800 text-xl py-4 rounded-lg font-bold uppercase"
                                    type="button"
                                    onClick={(e) => handleNextClick(e, 'unfiledTaxReturns', "No")}
                                >
                                    No
                                </button>
                            </div>
                        </fieldset>
                    )}

                    {/* STEP 4 */}
                    {step === 4 && (
                        <fieldset id="step4">
                            <legend className="text-2xl text-center text-gray-800 font-semibold min-w-sm max-w-sm">
                                What type of tax debt do you owe?
                            </legend>

                            <select
                                className="mt-6 border p-3 rounded-md w-full"
                                value={formData.taxDebtKind}
                                onChange={(e) =>
                                    updateField(
                                        "taxDebtKind",
                                        e.target.value
                                    )
                                }
                            >
                                <option value="Most of my tax debt is income tax (personal or business)">
                                    Most of my tax debt is income tax (personal or business) {formData.taxDebtKind}
                                </option>

                                <option value="My tax debt is mostly property tax">
                                    My tax debt is mostly property tax
                                </option>

                                <option value=" My tax debt is mostly unemployment
                                tax">
                                    My tax debt is mostly unemployment tax
                                </option>
                            </select>
                        </fieldset>
                    )}

                    {/* STEP 5 */}
                    {step === 5 && (
                        <fieldset id="step5">
                            <legend className="text-2xl text-center text-gray-800 font-semibold min-w-sm max-w-sm">
                                What is your total gross monthly income?
                            </legend>

                            <div className="mt-6">
                                <input
                                    type="range"
                                    min="1"
                                    max="10000"
                                    step="100"
                                    value={formData.grossMonthlyIncome}
                                    onChange={(e) =>
                                        updateField(
                                            "grossMonthlyIncome",
                                            e.target.value
                                        )
                                    }
                                    className="custom-slider w-full"
                                />

                                <p className="text-center mt-3 text-2xl font-medium">
                                    $
                                    {Number(
                                        formData.grossMonthlyIncome
                                    ).toLocaleString()}
                                </p>

                                {errors.grossMonthlyIncome && (
                                    <p className="text-red-500 mt-2">
                                        {errors.grossMonthlyIncome}
                                    </p>
                                )}
                            </div>
                        </fieldset>
                    )}

                    {/* STEP 6 */}
                    {step === 6 && (
                        <fieldset id="step6">
                            <legend className="text-2xl text-center text-gray-800 font-semibold min-w-sm max-w-sm">
                                What's your estimated credit score?
                            </legend>

                            <select
                                className="mt-6 border p-3 rounded-md w-full"
                                value={formData.creditScore}
                                onChange={(e) =>
                                    updateField(
                                        "creditScore",
                                        e.target.value
                                    )
                                }
                            >
                                <option value="800+">
                                    800+
                                </option>
                                <option value="740 - 799">
                                    740 - 799
                                </option>
                                <option value="620 - 739">
                                    620 - 739
                                </option>
                                <option value="580 - 619">
                                    580 - 619
                                </option>
                                <option value="300 - 579">
                                    300 - 579
                                </option>
                            </select>
                        </fieldset>
                    )}

                    {/* STEP 7 */}
                    {step === 7 && (
                        <fieldset id="step7">
                            <legend className="text-2xl text-center text-gray-800 font-semibold min-w-sm max-w-sm">
                                Are you currently enrolled in a payment installment agreement?
                            </legend>

                            <div className="flex items-center justify-center gap-6 mt-6">
                                <button className="flex items-center justify-center w-full border hover:border-gray-300 bg-white hover:bg-gray-100 hover:text-gray-900 text-gray-800 text-xl py-4 rounded-lg font-bold uppercase"
                                    type="button"
                                    onClick={(e) => handleNextClick(e, 'enrollmentPlan', "Yes")}
                                >
                                    Yes
                                </button>

                                <button className="flex items-center justify-center w-full border hover:border-gray-300 bg-white hover:bg-gray-100 hover:text-gray-900 text-gray-800 text-xl py-4 rounded-lg font-bold uppercase"
                                    type="button"
                                    onClick={(e) => handleNextClick(e, 'enrollmentPlan', "No")}
                                >
                                    No
                                </button>
                            </div>
                        </fieldset>
                    )}

                    {step === 8 && (
                        <fieldset id="step8">
                            <h2 className="text-2xl font-semibold text-center">
                                See If You Qualify For Tax Relief
                            </h2>

                            <p className="text-center text-gray-600 mt-2 mb-6">
                                Enter your information to receive your free tax relief review.
                            </p>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <input
                                        type="text"
                                        placeholder="First Name"
                                        value={formData.firstName}
                                        onChange={(e) =>
                                            updateField(
                                                "firstName",
                                                e.target.value
                                            )
                                        }
                                        className="border p-3 rounded-md w-full"
                                    />

                                    {errors.firstName && (
                                        <p className="text-red-500 mt-1">
                                            {errors.firstName}
                                        </p>
                                    )}
                                </div>

                                <div>
                                    <input
                                        type="text"
                                        placeholder="Last Name"
                                        value={formData.lastName}
                                        onChange={(e) =>
                                            updateField(
                                                "lastName",
                                                e.target.value
                                            )
                                        }
                                        className="border p-3 rounded-md w-full"
                                    />

                                    {errors.lastName && (
                                        <p className="text-red-500 mt-1">
                                            {errors.lastName}
                                        </p>
                                    )}
                                </div>
                            </div>

                            <div className="mt-4">
                                <input
                                    type="email"
                                    placeholder="Email Address"
                                    value={formData.email}
                                    onChange={(e) =>
                                        updateField(
                                            "email",
                                            e.target.value
                                        )
                                    }
                                    className="border p-3 rounded-md w-full"
                                />

                                {errors.email && (
                                    <p className="text-red-500 mt-1">
                                        {errors.email}
                                    </p>
                                )}
                            </div>

                            <div className="mt-4">
                                <input
                                    type="tel"
                                    placeholder="Phone Number"
                                    value={formData.phone}
                                    onChange={(e) =>
                                        updateField(
                                            "phone",
                                            e.target.value
                                        )
                                    }
                                    className="border p-3 rounded-md w-full"
                                />

                                {errors.phone && (
                                    <p className="text-red-500 mt-1">
                                        {errors.phone}
                                    </p>
                                )}
                            </div>

                            <div className="mt-5 text-xs text-gray-600 leading-relaxed">
                                By clicking "Get My Free Review", you agree  to the Terms & Conditions
                                and consent to be contacted
                                by phone, SMS, and email from
                                Ovation Tax Group and its partners regarding
                                your tax relief options. Consent is not a
                                condition of purchase. Message and data rates
                                may apply.
                            </div>
                        </fieldset>
                    )}
                    {/* STEP 9 */}
                    {step === 9 && (
                        <div className="text-center py-10" id="new_lead">
                            <h2 className="text-3xl font-bold">
                                Thank You!
                            </h2>

                            <p className="mt-4 text-lg text-gray-700">
                                Your information has been
                                submitted successfully. A tax expert from <b>Ovation Tax Group</b> will be contacting you shortly.
                            </p>
                            <p className="mt-4 text-xl">
                                To avoid waiting for a callback, call now to speak directly with a tax relief specialist. Our team can <b>review your situation immediately</b> and answer any questions about your options.
                            </p>

                            <a
                                href="tel:8449844926"
                                className="mt-8 inline-block bg-green-600 hover:bg-green-700 text-white text-2xl font-bold px-10 py-5 rounded-lg"
                            >
                                Call (844) 984-4926
                            </a>

                            <p className="mt-4 text-gray-600">
                                Representatives are standing by.
                            </p>
                        </div>
                    )}


                    {/* BUTTONS */}
                    {step < 9 && (
                        <div className="flex justify-between mt-8">
                            {step > 1 ? (
                                <button
                                    onClick={prevStep}
                                    id={`back-${step}`}
                                    className="px-5 py-3 border rounded-md"
                                >
                                    Back
                                </button>
                            ) : (
                                <div />
                            )}

                            {step !== 1 && <button
                                onClick={handleNext}
                                id={`button-${step}`}
                                className="bg-black text-white px-6 py-3 rounded-md"
                            >

                                {step === 8
                                    ? "Get My Free Review"
                                    : "Next"}
                            </button>}


                        </div>
                    )}
                    {process.env.REACT_APP_RECAPTCHA_SITE_KEY ? (
                        <>
                            {/* Invisible reCAPTCHA */}
                            <ReCAPTCHA
                                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                size="invisible"
                                ref={recaptchaRef}
                            />
                            <p>{status}</p>
                        </>
                    ) : (
                        <p style={{ color: 'red' }}>reCAPTCHA sitekey is missing.</p>
                    )}

                </div>}

        </div>
    )
}